import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

export const TopNavMenu = forwardRef((props, ref) => {
  const { as = 'div', children, className, ...rest } = props

  const classes = ['dev_dash__top-nav-menu', className ? className : '']
    .join(' ')
    .trim()

  const Comp = as
  return (
    <Comp className={classes} ref={ref} {...rest}>
      {children}
    </Comp>
  )
})

TopNavMenu.displayName = 'TopNavMenu'

TopNavMenu.propTypes = {
  as: PropTypes.any,
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
}
